// src/pages/Login.js
import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";

export default function Login() {
  const { connecter } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await connecter(email, password);
    } catch {
      setError("Email ou mot de passe incorrect.");
    }
    setLoading(false);
  }

  return (
    <div style={s.wrapper}>
      <div style={s.card}>
        <div style={s.header}>
          <div style={s.logo}>🎟️</div>
          <h1 style={s.title}>TomboLive</h1>
          <p style={s.subtitle}>Back-office Admin</p>
        </div>

        {error && <div style={s.error}>⚠️ {error}</div>}

        <form onSubmit={handleSubmit} style={s.form}>
          <input type="email" placeholder="Email admin" value={email}
            onChange={(e) => setEmail(e.target.value)} required style={s.input} autoFocus />
          <input type="password" placeholder="Mot de passe" value={password}
            onChange={(e) => setPassword(e.target.value)} required style={s.input} />
          <button type="submit" disabled={loading} style={s.btn}>
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}

const s = {
  wrapper: { minHeight:"100vh", background:"linear-gradient(135deg,#1a3a8f,#764ba2)", display:"flex", alignItems:"center", justifyContent:"center" },
  card: { background:"#fff", borderRadius:"16px", padding:"2.5rem 2rem", width:"100%", maxWidth:"380px", boxShadow:"0 20px 60px rgba(0,0,0,0.2)" },
  header: { textAlign:"center", marginBottom:"2rem" },
  logo: { fontSize:"3rem" },
  title: { fontSize:"1.5rem", fontWeight:"900", color:"#1a3a8f", margin:"0.25rem 0 0" },
  subtitle: { fontSize:"0.85rem", color:"#aaa", marginTop:"4px" },
  error: { background:"#ffebee", color:"#b71c1c", borderRadius:"8px", padding:"0.75rem 1rem", fontSize:"0.88rem", marginBottom:"1rem" },
  form: { display:"flex", flexDirection:"column", gap:"12px" },
  input: { padding:"0.75rem 1rem", border:"1.5px solid #e0e0e0", borderRadius:"10px", fontSize:"0.95rem", outline:"none" },
  btn: { padding:"0.85rem", background:"linear-gradient(135deg,#1a3a8f,#764ba2)", color:"#fff", border:"none", borderRadius:"10px", fontWeight:"700", cursor:"pointer", fontSize:"1rem" },
};
